import React, { useCallback } from "react";

//import localization
import { useTranslation } from "react-i18next";

import { Grid, Row, Col, Card, Statistic, Button, Divider, Tooltip } from "antd";
import { CheckOutlined, CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";

import { stateContext } from "./MainView";

import { onLegalPapersClick } from "../utils/consts";

const { useBreakpoint } = Grid;

function PlanView({ plans, query }) {
	//Locale Hooks
	const { t } = useTranslation();

	//Controller for window resizing.
	//Used in: Tooltip to show on hover or click
	const screen = useBreakpoint();

	//setFormState: from stateContext
	const [, setFormState] = React.useContext(stateContext);

	//Function that set the state of the context for SelectedPlan
	const onSelectOffer = useCallback(
		(plan) => {
			setFormState((formState) => {
				return { ...formState, CurrentStep: formState.CurrentStep + 1, SelectedPlan: plan };
			});
		},
		[setFormState]
	);

	return (
		<>
			<br />
			<h1 style={{ textAlign: "center", fontSize: 26 }}>{t("ChooseThePlanThatIsRightForYou")}</h1>
			<Row justify="center" gutter={12}>
				{plans.map((item) => (
					<Col key={item.ID} style={{ paddingBottom: 12 }}>
						<Card
							className="plan-card"
							title={item.Name}
							bordered={false}
							headStyle={{ textAlign: "center", background: "#d8061f", color: "#fff" }}
							actions={[
								<div style={{ margin: "0px 12px" }}>
									<div
										className="div-clickable"
										onClick={() => {
											onLegalPapersClick({ type: "TermsAndConditions", lng: query.Language });
										}}
									>
										{t("TermsAndConditions")}
									</div>
									<Divider style={{ margin: "14px 0px" }} />

									<div
										className="div-clickable"
										onClick={() => {
											onLegalPapersClick({ type: "PreContractualUpdate", lng: query.Language });
										}}
									>
										{t("PreContractualUpdate")}
									</div>
									<Divider style={{ margin: "14px 0px" }} />
									<Button
										type="primary"
										block
										onClick={() => {
											onSelectOffer(item);
										}}
									>
										{t("Select")}
									</Button>
								</div>
							]}
						>
							<div style={{ minHeight: 300, marginBottom: 135 }}>
								<Statistic value={item.MandatoryGrossAmount} valueStyle={{ color: "black", textAlign: "center", fontSize: 35 }} suffix="€" />
								<div style={{ textAlign: "center", fontSize: 24, marginTop: -10, marginBottom: 5 }}>{t("Total")}</div>
								<div className="cost-secondary">
									{t("TaxPremium")} {item.MandatoryTaxAmount}€
								</div>

								<table style={{ width: "100%" }}>
									<tbody>
										{item.Covers.map((content) => (
											<tr key={content.ID} style={{ borderTop: content?.GroupStart && "1px solid rgba(0, 0, 0, 0.06)" }}>
												<td style={{ display: "inline-block", paddingRight: 5 }}>{content.Supported ? <CheckOutlined style={{ color: "green" }} /> : <CloseOutlined style={{ color: "red" }} />}</td>
												<td style={{ paddingRight: 5 }}>{content.Name}</td>
												{content?.CovLimit && (
													<td style={{ whiteSpace: "nowrap", verticalAlign: "text-top" }}>
														{content?.CovLimit} €{" "}
														{content?.CovLimitText && (
															<Tooltip title={content?.CovLimitText} placement="top" trigger={screen.xs ? "click" : "hover"}>
																<InfoCircleOutlined />
															</Tooltip>
														)}
													</td>
												)}
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</Card>
					</Col>
				))}
			</Row>
			<br />
		</>
	);
}

export default React.memo(PlanView);
